import { ReportField } from '../api/reports/report';

export class Field {
  id: string;
  label: string;
  field: string | null;
  disabled: boolean;
  canDelete: boolean;
  updateable: boolean;
  isPlaceholder: boolean;
  metadata?: ReportField;

  constructor(
    label: string,
    field: string | null = null,
    disabled = false,
    canDelete = true,
    updateable = true,
    metadata?: ReportField,
    isPlaceholder = false,
  ) {
    this.id = crypto.randomUUID();
    this.label = label;
    this.field = field;
    this.disabled = disabled;
    this.canDelete = canDelete;
    this.updateable = updateable;
    this.metadata = metadata;
    this.isPlaceholder = isPlaceholder;
  }
}
